// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register('/service-worker.js', { scope: '/' })
            .then(registration => {
                console.log('Service Worker registered');
            })
            .catch(error => {
                console.error('Service Worker registration failed');
            });
    } else {
        console.log('Service workers are not supported in this browser.');
    }
});